const SLIDE_DURATION_MS = 350;
const CAPTION_TRANSITION_DURATION_MS = 225;
const container = "_b7ncabksv7";
const header = "_b7nh7eyq2g";
const headerText = "_b7nh1mwqv8q";
const heading = "_b7nhq7shis";
const elementToolbar = "_b7ne1qhmzdj";
const sliderWrapper = "_b7ns1ppvxhh";
const sliderContainer = "_b7ns5fg68s";
const slider = "_b7ns1cueki9";
const imageCaptionWrapper = "_b7ni1akpg91";
const imageCaptionTransition = "_b7nie6p2ju";

export { CAPTION_TRANSITION_DURATION_MS, SLIDE_DURATION_MS, container, elementToolbar, header, headerText, heading, imageCaptionTransition, imageCaptionWrapper, slider, sliderContainer, sliderWrapper };
import "./slider.style.linaria.module.css";
//# sourceMappingURL=slider.style.js.map
